export enum DatabaseMetadataEstado {
   /** No se pudo determinar el estado. */
   DESCONOCIDA = 'DESCONOCIDA',
   OK = 'OK',
   /** Existen relaciones en manager pero la base de datos no existe. */
   FANTASMA = 'FANTASMA',
   /** Base de datos existe, pero no tiene relaciones en manager. */
   HUERFANA = 'HUERFANA',
   /** Las cuentas relacionadas con la base de datos tienen un plan vencido. */
   EXPIRADA = 'EXPIRADA'
}

export enum AppInstanceescritorioItemEstado {
   DEFAULT = '',
   /** Item esta en papelera. */
   PAPELERA = 'P',
   /** Item fue eliminado permanentemente. */
   ELIMINADO = 'E'
}

export declare enum DeleteDatasourceResultStatus {
   DROPPED = 'dropped',
   UNKNOWN = 'unknown',
   ERROR = 'error',
   NOT_FOUND = 'not_found'
}
